module.exports = __webpack_public_path__ + "images/810e16396906d42019d7c18c6f185295.png";